import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

export interface EmspBoInvoiceListStatusCellProps
  extends CellContext<
    EmspUserInvoiceBaseModel,
    EmspUserInvoiceBaseModel['status']
  > {}

export const EmspBoInvoiceListStatusCell = (
  props: EmspBoInvoiceListStatusCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;
  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <span>{t(`delmonicos-shared-sdk.enums-invoice-status.${getValue()}`)}</span>
  );
};
